// Mastery signal v1 — implements the matrix in INTERACTION_FRAMEWORK.md §3.
//
// Every learning_interactions row carries a mastery_signal computed at write
// time. The version stamp is written into meta.masteryFormulaVersion so we can
// re-derive historical signals if the formula changes.

export const MASTERY_SIGNAL_VERSION = 1;

export type Correctness = 'correct' | 'incorrect' | 'partial' | 'n/a';
export type CognitiveLevel = 'L1_recall' | 'L2_interpret' | 'L3_apply';
export type MasterySignal =
  | 'strong_for'
  | 'for'
  | 'neutral'
  | 'against'
  | 'strong_against';

export function computeMasterySignal(
  correctness: Correctness,
  cognitiveLevel: CognitiveLevel | null | undefined,
): MasterySignal {
  if (correctness === 'n/a') return 'neutral';

  if (correctness === 'incorrect') return 'against';

  if (correctness === 'correct') {
    if (cognitiveLevel === 'L3_apply') return 'strong_for';
    return 'for';
  }

  // partial
  if (cognitiveLevel === 'L1_recall') return 'neutral';
  return 'for';
}
